import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { subscribeToNotifications, NotificationOptions } from '../utils/notifications';

const GlobalNotifications: React.FC = () => {
  const [notifications, setNotifications] = useState<NotificationOptions[]>([]);

  useEffect(() => {
    // Subscribe to notifications
    const unsubscribe = subscribeToNotifications((notification) => {
      if (notification.message) {
        // Add new notification
        setNotifications(prev => [...prev, { ...notification, id: Date.now() }]);
      } else {
        // Clear all notifications
        setNotifications([]);
      }
    });

    // Cleanup subscription
    return unsubscribe;
  }, []);

  const handleClose = (index: number) => {
    setNotifications(prev => prev.filter((_, i) => i !== index));
  };

  // Show the most recent notification
  const currentNotification = notifications[notifications.length - 1];

  return (
    <>
      {currentNotification && (
        <Snackbar
          open={!!currentNotification.message}
          autoHideDuration={currentNotification.autoHide ? currentNotification.duration : null}
          onClose={() => handleClose(notifications.length - 1)}
          anchorOrigin={{ 
            vertical: currentNotification.position?.includes('top') ? 'top' : 'bottom',
            horizontal: currentNotification.position?.includes('left') ? 'left' : 
                       currentNotification.position?.includes('right') ? 'right' : 'center'
          }}
        >
          <Alert
            onClose={() => handleClose(notifications.length - 1)}
            severity={currentNotification.severity}
            sx={{ width: '100%' }}
            elevation={6}
          >
            {currentNotification.message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default GlobalNotifications;
